<template>
    <div><!-- 計畫主檔 -->
        <CCard class="w-100">
            <CCardHeader>
                <strong>{{i18n('PlanMasterFile.PlanMasterFile')}}</strong>
            </CCardHeader>
            <CCardBody>
                    <CForm>
                        <div class="CForminline">
                            <div class="factory">
                                <p>&emsp;&emsp;{{$t('QuoteInfo_Vue.FactoryType')}}：</p>
                                    <div v-for="(item, key) in factoryList" :key="'factoryType_input_' + key">
                                       <input :disabled ="disableFactory" type="radio" :name="'planMaster_FactoryTypeOpt'" v-model="planMasterQueryParam.factoryId" :value="item.factoryId" >{{getFactoryCaption(item.factoryId,item.factoryCaption)}}
                                    </div>
                            </div>
                            <div class="name">
                                <p>&emsp;&emsp;{{$t('QualityInfo_Vue.RoeModel')}}：</p>
                                <input type="text" maxlength="50" v-model="planMasterQueryParam.roeModel">
                            </div>
                            <div class="supplier">
                                <p>&emsp;&emsp;{{$t('QualityInfo_Vue.DevelopPhase')}}：</p>
                                <input type="text" maxlength="50" v-model="planMasterQueryParam.developPhase">
                            </div>
                            <div class="status">
                                <p>&emsp;&emsp;{{$t('QualityInfo_Vue.RowStatus')}}：</p>
                                <div v-for="(item, key) in planMasterStatusList" :key="'planMasterStatus_input_' + key">
                                    <input type="radio" :name="'planMasterStatusOpt'" v-model="planMasterQueryParam.rowStatus" :value="item.planMasterStatusId" >{{item.planMasterStatusCaption}}
                                </div>
                            </div>
                            <div class="btn_group">
                                <button type="button" class="btn btn-edit mr-2" @click="planMasterQueryEvent">{{$t('Buttons.Query')}}</button>
                            </div>                            
                        </div>
                    </CForm>
            </CCardBody>
        </CCard>
        <CCard>
            <CCardBody>
                <table class="table ">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center">{{headers[0]}}</th>
                            <th class="text-center">{{headers[1]}}</th>
                            <th class="text-center">{{headers[2]}}</th>
                            <th class="text-center">{{headers[3]}}</th>
                            <th class="text-center">{{headers[4]}}</th>
                            <th class="text-center">{{headers[5]}}</th>
                            <th class="text-center">{{headers[6]}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr :class="isDeletedCss(item)" v-for="(item , index) in planMasterSearchResult" :key="index">                        
                            <td class="text-center">{{item.factoryName}}</td>
                            <td class="text-center">{{item.roeModel}}</td>
                            <td class="text-center">{{item.developPhase}}</td>
                            <td class="text-center">{{item.project}}</td>
                            <td class="text-center">{{fixDateTime(item.demandDate)}}</td>
                            <td class="text-center">{{fixDateTime(item.lastUpdateDate)}}</td>
                            <td class="text-center">
                                <router-link class="btn btn-sm btn-success mr-2" :disabled="isDeleted(item)" tag="button" @click.native="detailEvent(item)" to="">{{i18n('Buttons.DetailInfo')}}</router-link>
                                <button class="btn btn-sm btn-danger mr-2" :disabled="isDeleted(item)" v-if="isQMmanager" @click="deleteEvent(item)">{{i18n('Buttons.Delete')}}</button>
                            </td>
                        </tr> 
                    </tbody>
                </table>
            </CCardBody>
        </CCard>


    </div>
</template>
<script>
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    data() {
        return {
            headers:[
                this.i18n('PlanMasterFile.Factory'),this.i18n('PlanMasterFile.Machine'),this.i18n('PlanMasterFile.Phase'),this.i18n('PlanMasterFile.ProjectName'),
                this.i18n('PlanMasterFile.ProjectEstimatedTime'),this.i18n('PlanMasterFile.DateOfEstablishment'),this.i18n('PlanMasterFile.Function')
            ],            
            factoryList: this.$t('factoryQMList'), //廠別 清單
            planMasterStatusList: this.$t('planMasterStatusList'), //狀態 清單
            planMasterQueryParam: {
                hadQuery : false,
                factoryId : ''
            },
            planMasterSearchResult: []
        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.factoryList = this.$t('factoryQMList') //廠別 清單
            this.planMasterStatusList = this.$t('planMasterStatusList') //狀態 清單

            this.headers = [
                this.i18n('PlanMasterFile.Factory'),this.i18n('PlanMasterFile.Machine'),this.i18n('PlanMasterFile.Phase'),this.i18n('PlanMasterFile.ProjectName'),
                this.i18n('PlanMasterFile.ProjectEstimatedTime'),this.i18n('PlanMasterFile.DateOfEstablishment'),this.i18n('PlanMasterFile.Function')
            ]
        }
    },
    methods: {
        checkSearchParam(){ //檢核條件

        },
        planMasterQueryEvent (){
            this.checkSearchParam();
            this.planMasterQueryParam.hadQuery = true;
            this.doPlanMasterSearch (this.planMasterQueryParam);                
        },
        doPlanMasterSearch (param){
            const url = `${this.$apiUrl_Quality}/SearchPlanMasterPageAsync`;
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功          
                    this.planMasterSearchResult = response.data.rows;
                    this.setCacheQueryParam('PlanMaster_QueryParam' , param);                           
                }                    
            }); 
        },        
        detailEvent (item){//詳細資料        
            sessionStorage.setItem('planMasterId' , item.pid);
            this.$router.push('plan_masterfile_information');
        },
        deleteEvent (item){//刪除
            if(item.isDelete !== true && this.isQMmanager){
                const self =this;
                this.$confirm('此操作將永久刪除該筆資料, 是否繼續?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    self.doDeleteRow(item);
                });
            }
        },
        doDeleteRow (item){//呼叫刪除處理
            const url = `${this.$apiUrl_Quality}/DeletePlanMasterRow`;
            this.updateLoading(true);
            const param = {pid:item.pid};
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功          
                    item.isDelete =true;
                }                    
            }); 
        },
        isDeleted (item){
            if(item && item.isDelete === true){
                return  true;
            }
            return  false;
        },
        isDeletedCss (item){
            if(this.isDeleted(item)){
                return  'table-close';
            }
            return  '';
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(['lang'])
    },
	mounted() {
        this.getCacheQueryParam('PlanMaster_QueryParam' , this.planMasterQueryParam);
        const userFactoryId= this.userFactoryId;
        if(userFactoryId){
            this.planMasterQueryParam.factoryId = userFactoryId;
        }
        if(this.planMasterQueryParam.hadQuery){
            this.doPlanMasterSearch (this.planMasterQueryParam); 
        }
        sessionStorage.setItem('planMasterId' , '');
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .name, .factory, .supplier, .watch, .check, .status {
        display: flex;
        align-items: center;
        margin: .5rem 0;
        // width: 350px;

        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
        > .purchase_input {
            margin-bottom: 0;
        }
        > input {
            flex: 1;
            margin: 0 .5rem;
        }
            > div {
                margin: 0 .5rem;
            }        
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}

table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table th {
    background-color: #303c50;
    color: #fff;
}

.table tr:nth-child(even) {
    background-color: transparent;
}
.table tr.table-close {
    background-color: #D0D0D0;
}
</style>


